import {medicineReferences} from './medicineReferences.mjs';
const rows = value => Array.isArray(value) ? value : [];
const firstBy = (values, key) => {
  const index=new Map();for(const value of values){const id=key(value);if(!index.has(id))index.set(id,value);}return index;
};

export function hydrateMedicineDetails(summary, {medicine,variants}) {
  if(!medicine || !Array.isArray(variants)) throw new Error('Current medicine variations are unavailable. Refresh and try again.');
  const index=firstBy(rows(variants),variant=>variant.fixedVariantId);
  return {...summary,...medicine,variantInfo:rows(medicine.variants).map(ref=>index.get(ref.variantId)).filter(Boolean)};
}

// Build references once instead of scanning every variation for every medicine.
export function enrichMedicineCatalogue({ medicines, variants, categories, companies, tags, admins, language }) {
  const groups = firstBy(rows(medicines),group=>group.lang);
  const variationIndex = firstBy(rows(variants),item=>item.fixedVariantId);
  const adminIndex = new Map(rows(admins).map(item => [item._id, item.adminName]));
  const englishNames = new Map(rows(groups.get('en')?.data).map(item => [item.fixedMedicineId, item.genericBrand]));
  function enrich(code) {
    const companyIndex = firstBy(medicineReferences(companies,code,'company'),
      item => code === 'en' ? item.fixedCompanyId : item.companyDetectorId);
    const tagIndex = firstBy(medicineReferences(tags,code,'tag'),
      item => code === 'en' ? item.fixedId : item.tagDetectorId);
    const categoryIndex = new Map();
    for (const category of medicineReferences(categories,code,'category')) {
      const seen=new Set();
      for (const subcategory of rows(category.subCatList)) {
        const id=code === 'en' ? subcategory.fixedSubCatId : subcategory.subCatDetectorId;
        if(seen.has(id))continue;seen.add(id);
        categoryIndex.set(id,[...(categoryIndex.get(id)||[]),{category,subcategory}]);
      }
    }
    return rows(groups.get(code)?.data).map(item => {
      const found = rows(item.subCats).flatMap(ref => categoryIndex.get(ref.subCatId)||[]);
      return { ...item,
        catsArr: [...new Map(found.map(({ category }) => [category.fixedCatId, category])).values()],
        subCatsArr: found.map(({ subcategory }) => subcategory.subCatName),
        company: companyIndex.get(item.companyId),
        variantInfo: rows(item.variants).map(ref => variationIndex.get(ref.variantId)).filter(Boolean).map(variant => ({ ...variant })),
        tagsArr: rows(item.tags).map(ref => tagIndex.get(ref.tagsId)).filter(Boolean),
        searchName: code === 'en' ? item.genericBrand : englishNames.get(item.medicineDetectorId) || item.genericBrand,
        creatorName: adminIndex.get(item.creatorId),
        activeAdditionalSectionTab: item.additionalSections?.[0],
      };
    });
  }
  const selected = enrich(language);
  return { selected, english: language === 'en' ? selected : enrich('en') };
}
